<template>
  <div>
    <div class="subscription-container">
      <div
        class="subscription-content"
        :class="{ 'unfollow': !isActive }"
      >
        <p>{{ $t('subscription.number') }} <strong>{{ subscription.paymentId }}</strong></p>
        <p>{{ $t('subscription.status') }} <strong>{{ displayStatus }}</strong></p>
        <p v-if="isShownNextDeliverAt">
          {{ $t('subscription.next.payment') }} <strong>{{ formattedNextDeliverAt }}</strong>
        </p>
        <p v-if="isActive">
          {{ $t('subscription.linked.card') }} <strong>{{ formattedCardNumber }}</strong>
        </p>
        <p>{{ $t('transaction.recipient') }} <a :href="`mailto:${'user@gmail.com'}`">{{ subscription.email }}</a></p>
      </div>
      <div
        v-if="isCancelShow"
        class="subscription-cancel"
        @click="isConfirmationShown = true"
      >
        {{ $t('subscription.unsubscribe') }}
      </div>
      <div
        v-if="isConfirmationShow"
        class="subscription-confirmation"
      >
        <p v-html="$t('subscription.confirm.cancel.next.write-off')"></p>
        <div class="subscription-action">
          <cs-button width="100%" type="transparent" @click="$emit('unfollow')">
            {{ $t('common.yes') }}
          </cs-button>
          <cs-button width="100%" type="transparent" @click="isConfirmationShown = false">
            {{ $t('common.do.not.cancel') }}
          </cs-button>
        </div>
      </div>
    </div>
    <div v-if="inShownResumeButton" class="subscription-running-container">
      <a :href="subscription.payLink">
        <cs-button width="100%">{{ $t('subscription.resume') }}</cs-button>
      </a>
    </div>
  </div>
</template>

<script>
import { formatDateToCustomDate } from 'lib/utils/date';

const DATE_FORMAT = 'DD.MM.YY';

export default {
  name: 'SubscriptionCard',
  props: {
    subscription: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isConfirmationShown: false,
    };
  },
  computed: {
    isActive() {
      return this.subscription.status === 'ACTIVE';
    },
    isShownNextDeliverAt() {
      if (this.$validate.isNull(this.subscription.next_deliver_at)) {
        return false;
      }

      return this.isActive;
    },
    displayStatus() {
      if (this.isActive) {
        if (this.$validate.isPositiveNumber(this.subscription.trialDays)) {
          return this.$t('subscription.active.from', {
            date: formatDateToCustomDate(this.subscription.createdAt, DATE_FORMAT),
          });
        }

        return this.$t('subscription.active');
      }

      return this.$t('subscription.inactive');
    },
    isCancelShow() {
      return !this.isConfirmationShown && this.isActive;
    },
    isConfirmationShow() {
      return this.isConfirmationShown && this.isActive;
    },
    formattedNextDeliverAt() {
      if (!this.isShownNextDeliverAt) {
        return '';
      }

      return formatDateToCustomDate(this.subscription.next_deliver_at, DATE_FORMAT);
    },
    formattedCardNumber() {
      const { account_number: cardNumber } = this.subscription;
      const endNumbers = cardNumber.slice(-4);

      return `****${endNumbers}`;
    },
    inShownResumeButton() {
      if (!this.subscription.multiBill) {
        return false;
      }

      return !this.isActive;
    },
  },
};
</script>

<style lang="sass" scoped>
  p
    font-style: normal
    font-weight: normal
    font-size: 12px
    line-height: 30px
    color: rgba(33, 33, 33, 0.75)

  strong
    font-weight: 500
    font-size: 12px
    line-height: 16px
    color: #212121

  a
    font-style: normal
    font-weight: normal
    font-size: 12px
    line-height: 16px
    color: #9B51E0
    overflow: hidden
    text-overflow: ellipsis
    white-space: nowrap

  .subscription-container
    background: #FFFFFF
    border-radius: 5px

  .subscription-content
    padding: 10px 20px
    box-shadow: 0 1px 2px rgba(189, 189, 189, 0.5)
    border-radius: 5px 5px 0 0

    &.unfollow
      border-radius: 5px

    p
      display: flex
      align-items: center
      justify-content: space-between

    strong
      flex: 1
      max-width: 140px

      @media (max-width: 480px)
        flex: none

    a
      flex: 1
      max-width: 140px

      @media (max-width: 480px)
        flex: none

  .subscription-cancel
    font-size: 14px
    line-height: 50px
    text-align: center
    color: #9B51E0
    box-shadow: 0 1px 2px rgba(189, 189, 189, 0.5)
    border-radius: 0 0 5px 5px
    cursor: pointer

  .subscription-confirmation
    padding: 20px
    color: #212121
    box-shadow: 0 1px 2px rgba(189, 189, 189, 0.5)
    border-radius: 0 0 5px 5px

    p,
    strong
      font-size: 14px
      line-height: 20px
      color: #212121

    strong
      font-weight: 700

  .subscription-action
    display: flex
    justify-content: space-between
    margin-top: 20px

    @media (max-width: 480px)
      flex-direction: column

    *
      max-width: 140px
      flex: 1

      @media (max-width: 480px)
        max-width: 100%

        &:not(:last-child)
          margin-bottom: 10px

  .subscription-running-container
    margin-top: 20px
    font-size: 0

    a
      width: 100%
</style>
